import React from 'react'; // eslint-disable-line
import { Grid, Typography, withStyles } from '@material-ui/core';
import { FullWidthSearchSelectField, FormHeading, ButtonWrapper } from '../../../forms';
import { requiredValidator } from '../../../forms/validations';
import styles, { StyledComponent } from '../../../styles/styles';
import { BeneficiaryOption } from '../../reducer';
import { ClaimType } from '../../../claim/claim-types';
import { Nullable } from '../../../shared-types';

type Props = StyledComponent & {
    beneficiaryOptions: BeneficiaryOption[];
    claimType?: Nullable<ClaimType>;
};
const addBeneficiaryDetailView: React.FunctionComponent<Props> = ({
    beneficiaryOptions,
    claimType,
}: Props) => {
    let title = '';
    let placeholder = '';
    if (claimType === ClaimType.RADeath) {
        title = 'Add Beneficiaries/Dependents/Payees';
        placeholder = 'Beneficiaries/Dependents/Payees';
    } else {
        title = 'Add Beneficiary';
        placeholder = 'Beneficiary';
    }
    return (
        <React.Fragment>
            <ButtonWrapper>
                <FormHeading text={title} />
                <Grid container spacing={5} style={{ marginBottom: '120px' }}>
                    {claimType === ClaimType.RADeath && (
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="div"
                            style={{
                                marginTop: '10px',
                                display: 'flex',
                                backgroundColor: '#E6EDFF',
                                height: '27px',
                            }}
                        >
                            <span
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 20,
                                    height: 12,
                                    backgroundColor: '#007BFF',
                                    color: 'white',
                                    borderRadius: '40%',
                                    marginLeft: 18,
                                    fontSize: 14,
                                    marginTop: '5px',
                                    marginRight: 14,
                                }}
                            >
                                i
                            </span>
                            Please ensure all&nbsp;
                            <strong> Personal details & Address details</strong>&nbsp; are completed
                            in the synopsis to display all beneficiaries here
                        </Typography>
                    )}
                    <Grid item xs={6} lg={6}>
                        <FullWidthSearchSelectField
                            name="paymentBeneficiary"
                            label={placeholder}
                            validate={requiredValidator}
                            options={beneficiaryOptions}
                        />
                    </Grid>
                </Grid>
            </ButtonWrapper>
        </React.Fragment>
    );
};

export const AddBeneficiaryDetailView = withStyles(styles)(addBeneficiaryDetailView);
